exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbody[data-v-48994db5] {\n  overflow: hidden;\n}\n", ""]);

// exports
